import React from 'react'

import { formSrpUrl, isEmpty, replaceQueryInUrl, ONWARD_DIR_ARROW } from 'utils/browserHelper'
import { ReactComponent as RightArr } from 'assets/icons/rightarr.svg'
import { useHistory } from 'react-router-dom'

const popularCity = [
    {
        adults: 1,
        childs: 0,
        infants: 0,
        class: 'Economy',
        depart_date: '',
        from: 'BLR',
        to: 'BOM',
        intl: 'n',
        origin: 'BLR - Bangalore, IN',
        destination: 'BOM - Mumbai, IN',
        sd: 1658385293138,
        rnd_one: 'O',
        sourceCountry: 'Bangalore',
        destinationCountry: 'Mumbai'
    },
    {
        adults: 1,
        childs: 0,
        infants: 0,
        class: 'Economy',
        depart_date: '',
        from: 'BLR',
        to: 'DEL',
        intl: 'n',
        origin: 'BLR - Bangalore, IN',
        destination: 'DEL - New Delhi, IN',
        sd: 1658385278829,
        rnd_one: 'O',
        sourceCountry: 'Bangalore',
        destinationCountry: 'New Delhi'
    },
    {
        adults: 1,
        childs: 0,
        infants: 0,
        class: 'Economy',
        depart_date: '',
        from: 'BOM',
        to: 'DEL',
        intl: 'n',
        origin: 'BOM - Mumbai, IN',
        destination: 'DEL - New Delhi, IN',
        sd: 1658385278829,
        rnd_one: 'O',
        sourceCountry: 'Mumbai',
        destinationCountry: 'New Delhi'
    }
]

const PopularSearch = () => {
    const browserHistory = useHistory()

    return (
        <>
            <div className="flex flex-between mt-12 mb-6">
                <div className="fs-7 fw-600 c-neutral-900">{'Popular searches'}</div>
            </div>
            <ul className="bc-neutral-100 flex ls-reset mt-2 c-pointer" style={{ gap: 16 }}>
                {popularCity.map((item, index) => (
                    <li
                        className="ba bc-neutral-100 br-8 listItemHover"
                        style={{ width: 224, height: 72 }}
                        onClick={() => {
                            replaceQueryInUrl(browserHistory, item)
                        }}
                    >
                        <div className="ml-4 mr-4 mt-4 mb-4 p-relative">
                            <a href={formSrpUrl(item)} className="td-none fs-4 fw-500">
                                {item.sourceCountry && item.destinationCountry && (
                                    <p className="fw-600 fs-3">
                                        {item.sourceCountry} {!isEmpty(item.return_date) ? '⇄' : ONWARD_DIR_ARROW}{' '}
                                        {item.destinationCountry}
                                    </p>
                                )}
                            </a>
                            <RightArr className="p-absolute" style={{ right: 3, top: '38%' }} />
                            <p className="c-neutral-400 fs-2 mt-1">Next week</p>
                        </div>
                    </li>
                ))}
            </ul>
        </>
    )
}

export default PopularSearch
